// extracted by mini-css-extract-plugin
export default {"dropoffLocations":"DropoffLocations_dropoffLocations__22+UU","dropoffLocations__form":"DropoffLocations_dropoffLocations__form__tB4e-"};